var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8679 24.1602C19.9031 21.5975 23.9276 19.9081 25.9412 19.0918C31.6906 16.7611 32.8852 16.3563 33.6639 16.3426C33.8351 16.34 34.2181 16.3813 34.4661 16.5775C34.6756 16.7431 34.7332 16.9669 34.7608 17.1239C34.7883 17.281 34.8227 17.6387 34.7954 17.9182C34.4838 21.1087 33.1357 28.8511 32.4498 32.4245C32.1597 33.9365 31.5882 34.4435 31.035 34.4931C29.8328 34.6009 28.9199 33.7187 27.7554 32.9748C25.9333 31.8107 24.904 31.0861 23.1353 29.9501C21.0913 28.6374 22.4163 27.9159 23.5812 26.7367C23.886 26.4281 29.1831 21.7323 29.2857 21.3063C29.2985 21.253 29.3104 21.0545 29.1893 20.9496C29.0683 20.8447 28.8896 20.8806 28.7607 20.9091C28.578 20.9496 25.6671 22.8247 20.0282 26.5344C19.202 27.0874 18.4536 27.3568 17.7831 27.3427C17.0439 27.3271 15.622 26.9353 14.5649 26.6005C13.2684 26.1897 12.238 25.9725 12.3277 25.275C12.3744 24.9116 12.8878 24.5401 13.8679 24.1602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.59f6e56369f47c9be4f9a90221f88883.svg";
export { ForwardRef as ReactComponent };